import React from 'react';
import { Search, ArrowUpDown, Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

type SortField = 'name';

interface ClientsHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortBy: SortField;
  onSortChange: (value: SortField) => void;
  sortDirection: 'asc' | 'desc';
  onSortDirectionChange: () => void;
  onAddNewClick: () => void;
}

export const ClientsHeader: React.FC<ClientsHeaderProps> = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
  sortDirection,
  onSortDirectionChange,
  onAddNewClick,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input 
          placeholder="Search clients..." 
          id="client-search"
          className="pl-9"
          value={searchTerm}
          autoComplete="off"
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      
      <Select 
        value={sortBy} 
        onValueChange={onSortChange}
      >
        <SelectTrigger className="w-[180px] flex-shrink-0 text-foreground">
          <SelectValue placeholder="Sort by..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="name">Name</SelectItem>
        </SelectContent>
      </Select>

      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onSortDirectionChange}
        aria-label="Toggle sort direction"
        className="flex-shrink-0 text-muted-foreground"
      >
        <ArrowUpDown className={cn("h-4 w-4 transition-transform", sortDirection === 'desc' && "rotate-180")} />
      </Button>

      <Button size="icon" className="flex-shrink-0" onClick={onAddNewClick} aria-label="Add new client">
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
};
